module.exports = __webpack_public_path__ + "img/山楂1.70c543e1.png";